import { render, staticRenderFns } from "./CampaignSmsBuilderModal.vue?vue&type=template&id=2c56600d&scoped=true"
import script from "./CampaignSmsBuilderModal.vue?vue&type=script&lang=js"
export * from "./CampaignSmsBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignSmsBuilderModal.vue?vue&type=style&index=0&id=2c56600d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56600d",
  null
  
)

export default component.exports